import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const MobileAppSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-slate-800 to-slate-900" data-testid="mobile-app-section">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* App Icon/Logo */}
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 bg-white rounded-3xl shadow-2xl overflow-hidden transform hover:scale-105 transition-transform">
              <img 
                src="/images/hero-girls.jpg" 
                alt="NokMechik App" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          
          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            <span className="inline-block text-xs font-semibold tracking-widest text-teal-400 uppercase mb-3">
              Coming Soon
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Get the NokMechik App
            </h2>
            <p className="text-slate-300 mb-6 max-w-lg">
              Access courses, chat with your co-admin, track your progress, and stay connected with the NokMechik community - all from your mobile device.
            </p>
            
            {/* Download Buttons */}
            <div className="flex flex-wrap justify-center md:justify-start gap-4">
              <Button 
                size="lg" 
                className="bg-white text-slate-800 hover:bg-slate-100 rounded-xl px-6 py-3 flex items-center gap-3 shadow-lg"
                data-testid="app-store-btn"
                disabled
              >
                <svg className="w-7 h-7" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <div className="text-left">
                  <p className="text-[10px] opacity-70">Download on the</p>
                  <p className="text-sm font-semibold -mt-0.5">App Store</p>
                </div>
              </Button>
              
              <Button 
                size="lg" 
                className="bg-white text-slate-800 hover:bg-slate-100 rounded-xl px-6 py-3 flex items-center gap-3 shadow-lg"
                data-testid="play-store-btn"
                disabled
              >
                <svg className="w-7 h-7" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                <div className="text-left">
                  <p className="text-[10px] opacity-70">Get it on</p>
                  <p className="text-sm font-semibold -mt-0.5">Google Play</p>
                </div>
              </Button>
            </div>
            
            <p className="text-xs text-slate-500 mt-4">
              Mobile app launching soon. Stay tuned for updates!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;
